import { useRef, useState, useEffect } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";
import imageImg from "../../../../picture/slika.png";
import textImg from "../../../../picture/text.png";
import wordImg from "../../../../picture/word.png";
import pdfImg from "../../../../picture/pdf.png";
import scanImg from "../../../../picture/scan.png";
import editImg from "../../../../picture/edit.png";
import uploadImg from "../../../../picture/UploadDocument.png";
import downloadImg from "../../../../picture/DownloadFile.png";
import visibleImg from "../../../../picture/Visible.png";
import forwardImg from "../../../../picture/forward.png";
import notificationImg from "../../../../picture/notification.png";
import printImg from "../../../../picture/print.png";
import letterAImg from "../../../../picture/letterA.png";
import ConfirmationModal from "../../FolderDocument/ConfirmationModal";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
  icon: { width: "30px", height: "30px" },
  filledDiv: { width: "25px", height: "25px", margin: "auto" },
};

// Računa boju statusa na osnovu datum_isteka i notifikacija_dana
// datum_isteka je u formatu "d.m.Y." koji dolazi sa servera
function calculateColor(datumIstekaFormatted, notifikacijaDana = 7) {
  if (!datumIstekaFormatted) return "green";

  // Parsiramo "dd.mm.yyyy." format
  const parts = datumIstekaFormatted.replace(/\.$/, "").split(".");
  if (parts.length < 3) return "green";
  const datumIsteka = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
  const danas = new Date();
  danas.setHours(0, 0, 0, 0);

  if (datumIsteka < danas) return "red";

  const datumNotifikacije = new Date(datumIsteka);
  datumNotifikacije.setDate(datumNotifikacije.getDate() - notifikacijaDana);

  if (danas >= datumNotifikacije) return "orange";

  return "green";
}

function DokumentaZaposlenogVazeca({
  dokumenta: initialDocs,
  moveToArhiviraniDoc,
  onStatusChange, // callback ka roditelju da ažurira global status
}) {
  const { dictionary, baseUrl, apiKey, loggedUser } = useGlobalContext();

  const [localDocs, setLocalDocs] = useState(initialDocs);
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: "",
  });
  const [isOpenEditConfirm, setIsOpenEditConfirm] = useState(false);
  const [fileNewDocument, setFileNewDocument] = useState(null);
  const [newExpiryDate, setNewExpiryDate] = useState("");

  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [currentDocForAlarm, setCurrentDocForAlarm] = useState(null);
  const [alarmDays, setAlarmDays] = useState("");

  const fileInputRef = useRef();

  useEffect(() => {
    setLocalDocs(initialDocs);
  }, [initialDocs]);

  // Kad se lokalDocs promeni, obavesti roditelja o novom globalnom statusu
  const prevStatusRef = useRef(null);
  useEffect(() => {
    if (!onStatusChange) return;
    const allColors = localDocs.flatMap((doc) =>
      ["text", "word", "pdf", "image", "scan"]
        .map((t) => doc[t])
        .filter((c) => c && c !== "transparent"),
    );
    let newStatus;
    if (allColors.includes("red")) newStatus = "wrong";
    else if (allColors.includes("orange")) newStatus = "notif";
    else if (allColors.length > 0) newStatus = "correct";
    else newStatus = "empty";

    if (newStatus !== prevStatusRef.current) {
      prevStatusRef.current = newStatus;
      onStatusChange(newStatus);
    }
  }, [localDocs]);

  const handleSelectDocument = (docId, type) => {
    setSelectedField((prev) =>
      prev.documentId === docId && prev.documentType === type
        ? { documentId: "", documentType: "" }
        : { documentId: docId, documentType: type },
    );
  };

  const handleDownload = () => {
    const doc = localDocs.find((d) => d.id === selectedField.documentId);

    console.log("=== DOWNLOAD DEBUG ===");
    console.log("selectedField:", selectedField);
    console.log("doc pronadjen:", doc);

    if (!doc) {
      alert(
        "Prvo kliknite na kockicu (verziju) dokumenta koji želite da skinete.",
      );
      return;
    }

    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];

    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }

    window.open(
      `${baseUrl}/zaposleni/download_document.php?path=${encodeURIComponent(relativePath)}`,
      "_blank",
    );
  };

  const handleConfirmEdit = async () => {
    const formData = new FormData();
    formData.append("file", fileNewDocument);
    formData.append("document_id", selectedField.documentId);
    formData.append("document_type", selectedField.documentType);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    if (newExpiryDate) {
      formData.append("datum_isteka", newExpiryDate);
    }

    try {
      const { data } = await axios.post(
        `${baseUrl}/zaposleni/update_existing_document.php`,
        formData,
      );
      if (data.status === 200) {
        setLocalDocs((prev) =>
          prev.map((d) =>
            d.id === selectedField.documentId
              ? { ...d, [selectedField.documentType]: "green" }
              : d,
          ),
        );
        window.dispatchEvent(new Event("machineAdded"));
        setIsOpenEditConfirm(false);
        setFileNewDocument(null);
        setNewExpiryDate("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleShare = async (doc) => {
    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];

    if (!version || !relativePath) {
      alert(
        "Prvo selektujte verziju dokumenta (kockicu) koju želite da podelite.",
      );
      return;
    }
    if (!navigator.canShare) {
      alert("Vaš browser ne podržava sistemsko deljenje fajlova.");
      return;
    }
    try {
      const fileUrl = `${baseUrl}/${relativePath}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const fileName = relativePath.split("/").pop().replace(/^\d+_/, "");
      const file = new File([blob], fileName, { type: blob.type });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: doc.naziv,
          text: `Delim dokument: ${doc.naziv}`,
        });
      } else {
        alert("Browser ne dozvoljava deljenje ovog tipa fajla.");
      }
    } catch (error) {
      console.error("Greška pri deljenju:", error);
      alert("Došlo je do greške. Pokušajte sa običnim preuzimanjem.");
    }
  };

  const handlePreview = async (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo selektujte verziju dokumenta (kockicu) u ovom redu.");
      return;
    }

    if (doc.is_obrazac6) {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija6/obrazac6_preview.php`,
          {
            obrazac6_id: doc.obrazac6_id,
          },
        );
        if (data.status === 200) {
          const pw = window.open("", "_blank");
          pw.document.write(data.html);
          pw.document.close();
        }
      } catch (e) {
        console.error(e);
      }
      return;
    }

    if (doc.is_mention) {
      const rows = doc.mentions
        .map(
          (m) => `
    <tr>
      <td style="padding:8px;border:1px solid #ccc">${m.datum}</td>
      <td style="padding:8px;border:1px solid #ccc">${m.location_name}</td>
      <td style="padding:8px;border:1px solid #ccc">${m.item_title}</td>
      <td style="padding:8px;border:1px solid #ccc;white-space:pre-line">${m.mention_text || ""}</td>
    </tr>
  `,
        )
        .join("");

      const html = `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="UTF-8"/>
<title>Досије — помињања</title>
<style>
  body { font-family: "Times New Roman", serif; font-size: 12pt; padding: 30px; max-width: 900px; margin: 0 auto; }
  h2 { font-size: 14pt; border-bottom: 2px solid #000; padding-bottom: 6px; margin-bottom: 20px; }
  table { width: 100%; border-collapse: collapse; }
  th { background: #f0f0f0; padding: 8px; border: 1px solid #ccc; text-align: left; font-size: 11pt; }
  td { font-size: 11pt; }
  .print-btn { position: fixed; bottom: 20px; right: 20px; padding: 8px 24px; background: #1565C0; color: #fff; border: none; border-radius: 4px; font-size: 13px; cursor: pointer; }
  @media print { .print-btn { display: none; } }
</style>
</head>
<body>
  <h2>Досије — помињања запосленог</h2>
  <table>
    <thead>
      <tr>
        <th>Датум</th>
        <th>Локација</th>
        <th>Наслов</th>
        <th>Текст</th>
      </tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>
  <button class="print-btn" onclick="window.print()">🖨 Штампај</button>
</body>
</html>`;

      const pw = window.open("", "_blank");
      pw.document.write(html);
      pw.document.close();
      return;
    }

    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    window.open(
      `${baseUrl.replace("/api", "")}/${relativePath}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handlePrint = async (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo selektujte verziju dokumenta (kockicu) u ovom redu.");
      return;
    }

    if (doc.is_obrazac6) {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija6/obrazac6_preview.php`,
          {
            obrazac6_id: doc.obrazac6_id,
          },
        );
        if (data.status === 200) {
          const pw = window.open("", "_blank");
          pw.document.write(data.html);
          pw.document.close();
          pw.onload = () => pw.print();
        }
      } catch (e) {
        console.error(e);
      }
      return;
    }

    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }

    const fileUrl = `${baseUrl.replace("/api", "")}/${relativePath}`;
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(iframe);
        }, 2000);
      };
    } catch (error) {
      console.error("Greška pri štampi:", error);
      window.open(fileUrl, "_blank");
    }
  };

  const moveToArhivirani = async (doc) => {
    if (!window.confirm(`Arhivirati dokument: ${doc.naziv}?`)) return;
    setLocalDocs((prev) => prev.filter((d) => d.id !== doc.id));
    moveToArhiviraniDoc(doc);
  };

  const handleOpenNotification = (doc) => {
    setCurrentDocForAlarm(doc);
    setAlarmDays(doc.notifikacija_dana ?? 7);
    setIsOpenNotification(true);
  };

  const handleSaveAlarm = async () => {
    const formData = new FormData();
    formData.append("document_id", currentDocForAlarm.id);
    formData.append("notifikacija_dana", alarmDays);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/zaposleni/update_document_alarm.php`,
        formData,
      );
      if (data.status === 200) {
        setLocalDocs((prev) =>
          prev.map((d) =>
            d.id === currentDocForAlarm.id
              ? { ...d, notifikacija_dana: Number(alarmDays) }
              : d,
          ),
        );
        window.dispatchEvent(new Event("machineAdded"));
        setIsOpenNotification(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <table style={{ width: "88%", float: "right" }}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <img src={textImg} style={{ width: "30px" }} alt="text" />
            </th>
            <th style={styles.smallCell}>
              <img src={wordImg} style={{ width: "30px" }} alt="word" />
            </th>
            <th style={styles.smallCell}>
              <img src={pdfImg} style={{ width: "30px" }} alt="pdf" />
            </th>
            <th style={styles.smallCell}>
              <img src={imageImg} style={{ width: "30px" }} alt="img" />
            </th>
            <th style={styles.smallCell}>
              <img src={scanImg} style={{ width: "30px" }} alt="scan" />
            </th>

            {/* NOVE KOLONE VRSTA I NAZIV */}
            <th
              style={{
                ...styles.cell,
                width: "15%",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              VRSTA
            </th>
            <th
              style={{
                ...styles.cell,
                width: "35%",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              {dictionary["vazecaDokumenta"]}
            </th>

            <th colSpan="8"></th>
          </tr>
        </thead>
        <tbody>
          {localDocs.map((doc) => (
            <tr key={doc.id}>
              {["text", "word", "pdf", "image", "scan"].map((type) => (
                <td
                  key={type}
                  onClick={() => handleSelectDocument(doc.id, type)}
                  style={{
                    ...styles.smallCell,
                    border:
                      selectedField.documentId === doc.id &&
                      selectedField.documentType === type
                        ? "2px solid black"
                        : "",
                  }}
                >
                  <div
                    style={{ ...styles.filledDiv, backgroundColor: doc[type] }}
                  ></div>
                </td>
              ))}

              {/* ISPIS VREDNOSTI ZA VRSTU I NAZIV */}
              <td style={{ ...styles.cell, textAlign: "left" }}>
                {doc.vrsta || "/"}
              </td>
              <td style={{ ...styles.cell, textAlign: "left" }}>{doc.naziv}</td>

              <td style={styles.smallCell}>
                <img src={editImg} style={{ width: "30px" }} alt="edit" />
              </td>
              <td style={styles.smallCell} onClick={handleDownload}>
                <img
                  src={downloadImg}
                  style={{ width: "25px" }}
                  alt="download"
                />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => {
                  if (!selectedField.documentId) {
                    alert("Prvo odaberi verziju (kockicu)");
                    return;
                  }
                  fileInputRef.current.click();
                }}
              >
                <img src={uploadImg} style={{ width: "25px" }} alt="upload" />
              </td>
              <td style={styles.smallCell} onClick={() => handleShare(doc)}>
                <img src={forwardImg} style={{ width: "30px" }} alt="forward" />
              </td>
              <td style={styles.smallCell} onClick={() => handlePrint(doc)}>
                <img src={printImg} style={{ width: "20px" }} alt="print" />
              </td>
              <td style={styles.smallCell} onClick={() => handlePreview(doc)}>
                <img src={visibleImg} style={{ width: "30px" }} alt="preview" />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => moveToArhivirani(doc)}
              >
                <img
                  src={letterAImg}
                  style={{ width: "20px" }}
                  alt="arhivirati"
                />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleOpenNotification(doc)}
              >
                <img
                  src={notificationImg}
                  style={{ width: "30px" }}
                  alt="alarm"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            setFileNewDocument(file);
            setIsOpenEditConfirm(true);
          }
        }}
      />

      {isOpenEditConfirm && (
        <ConfirmationModal
          text="Potvrdite slanje i datum isteka:"
          handleConfirm={handleConfirmEdit}
          handleCancel={() => {
            setIsOpenEditConfirm(false);
            setNewExpiryDate("");
          }}
        >
          <input
            type="date"
            value={newExpiryDate}
            onChange={(e) => setNewExpiryDate(e.target.value)}
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          />
        </ConfirmationModal>
      )}

      {isOpenNotification && currentDocForAlarm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            fontSize: "larger",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              width: "350px",
              borderRadius: "10px",
              position: "relative",
            }}
          >
            <div
              onClick={() => setIsOpenNotification(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                fontSize: "24px",
                fontWeight: "bold",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#000",
              }}
            >
              ✕
            </div>
            <div
              style={{
                ...styles.cell,
                border: "none",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              <div style={{ marginBottom: "5px" }}>
                Документ: <strong>{currentDocForAlarm.naziv}</strong>
              </div>
              <div style={{ marginBottom: "15px" }}>
                Истиче:{" "}
                <strong>
                  {currentDocForAlarm.datum_isteka
                    ? currentDocForAlarm.datum_isteka
                        .replace(/\.$/, "")
                        .split("-")
                        .reverse()
                        .join(".")
                    : "Неодређено"}
                </strong>
              </div>
              <label style={{ display: "block", marginBottom: "10px" }}>
                Аларм:
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <button
                    onClick={() =>
                      setAlarmDays((prev) => Math.max(1, Number(prev) - 1))
                    }
                    style={{
                      width: "40px",
                      height: "40px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    value={alarmDays}
                    onChange={(e) => setAlarmDays(e.target.value)}
                    style={{
                      width: "50px",
                      height: "40px",
                      padding: "8px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  />
                  <button
                    onClick={() => setAlarmDays((prev) => Number(prev) + 1)}
                    style={{
                      width: "40px",
                      height: "40px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    +
                  </button>
                </div>
                <div
                  className="dos-btn"
                  style={{
                    textAlign: "center",
                    padding: "10px 20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    width: "150px",
                    height: "40px",
                    backgroundColor: "#eee",
                  }}
                  onClick={handleSaveAlarm}
                >
                  ПОТВРДИ
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DokumentaZaposlenogVazeca;
